// i18n initialization for the app: sets up language resources and configuration.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import it from './locales/it.json';
import de from './locales/de.json';
import fr from './locales/fr.json';

// Rileva la lingua preferita dall'utente
const getInitialLanguage = () => {
    // 1. Controlla se c'è una lingua salvata nel localStorage
    const savedLanguage = localStorage.getItem('preferred-language');
    if (savedLanguage && ['it', 'en', 'de', 'fr'].includes(savedLanguage)) {
        return savedLanguage;
    }

    // 2. Rileva dalla lingua del browser
    const browserLanguage = navigator.language.split('-')[0];
    if (['it', 'en', 'de', 'fr'].includes(browserLanguage)) {
        return browserLanguage;
    }

    // 3. Default: italiano
    return 'it';
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            it: { translation: it },
            de: { translation: de },
            fr: { translation: fr }
        },
        lng: getInitialLanguage(),
        fallbackLng: 'it',
        // React already escapes output, so disabling escaping is safe here.
        interpolation: { escapeValue: false }
    });

export default i18n;